import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import {
  UpdateVmsBoardsConnectivityStatusInput,
  UpdateVmsBoardsConnectivityStatusOutput,
} from "./queries/types";
import { UpdateVmsBoardsConnectivityStatus } from "./queries/mutation";
import { emptyMessage } from "../../../../utils/constants";
import { Operation } from "../../../../utils/Enum.types";
import { Button } from "../../../../stories/Button/Button";
import useUrlParams from "../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import useToken from "../../../../customHooks/useToken";
import { GetVmsBoardDetails } from "./queries/queries";
import MessageModal from "../../../../customComponents/MessageModal";

const CheckConnectivity = () => {
  const [message, setMessage] = useState(emptyMessage);
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { handleToken } = useToken();

  const [UpdateCustomerDetails, { loading: UpdateLoading }] = useMutation<
    UpdateVmsBoardsConnectivityStatusOutput,
    UpdateVmsBoardsConnectivityStatusInput
  >(UpdateVmsBoardsConnectivityStatus, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const hanldeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = await handleToken();
      if (token && customer_id) {
        UpdateCustomerDetails({
          variables: {
            customerID: customer_id ? customer_id : 0,
            token,
            user_details,
          },
          refetchQueries: [
            {
              query: GetVmsBoardDetails,
              variables: {
                customerID: customer_id,
                token,
                user_details,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.UpdateVmsBoardsConnectivityStatus) {
            setMessage({
              flag: true,
              message: `Successfully updated `,
              operation: Operation.CREATE,
            });
          }
        });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  return (
    <div className="vms-boards-button">
      <Button onClick={hanldeSubmit}>Check Connectivity</Button>
      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default CheckConnectivity;
